<!--~
~ Copyright (c) 2010-2020 California CAD Solutions, Inc. Licensed subject
~ to an End-User License Agreement included in a separate file named EULA.txt
~ that is distributed with this file.
-->
@if (!(tableEditActive && isEditable)) {
  @if (!fieldDefinition.type || fieldDefinition.type === 'string') {
    <dash-gis-string-field [fieldDefinition]="fieldDefinition" [rowData]="rowData"></dash-gis-string-field>
  }
  @if (fieldDefinition.type && fieldDefinition.type === 'number') {
    <dash-gis-number-field [fieldDefinition]="fieldDefinition" [rowData]="rowData"></dash-gis-number-field>
  }
  @if (fieldDefinition.type && fieldDefinition.type === 'date') {
    <dash-gis-date-field [fieldDefinition]="fieldDefinition" [rowData]="rowData"></dash-gis-date-field>
  }
  @if (fieldDefinition.type && fieldDefinition.type === 'link') {
    <dash-gis-link-field [fieldDefinition]="fieldDefinition" [rowData]="rowData"></dash-gis-link-field>
  }
  @if (fieldDefinition.type && fieldDefinition.type === 'report') {
    <dash-gis-reportlink-field [fieldDefinition]="fieldDefinition" [rowData]="rowData"></dash-gis-reportlink-field>
  }
  @if (fieldDefinition.type && fieldDefinition.type === 'document') {
    <dash-gis-document-link-field [fieldDefinition]="fieldDefinition" [rowData]="rowData"></dash-gis-document-link-field>
  }
  @if (fieldDefinition.type && fieldDefinition.type === 'video') {
    <dash-gis-video-field [fieldDefinition]="fieldDefinition" [rowData]="rowData"></dash-gis-video-field>
  }
  @if (fieldDefinition.type && fieldDefinition.type === 'qrcode') {
    <dash-gis-qr-code-field [fieldDefinition]="fieldDefinition" [rowData]="rowData"></dash-gis-qr-code-field>
  }
}
@if (tableEditActive && isEditable) {
  <ng-container [formGroup]="dataFormGroup">
    <ng-container [formGroupName]="rowData[dataForm.definition.dbKey]">
      @switch (dataFormField.uiType) {
        @case ('text') {
          <input class="inline-input" [formControlName]="fieldDefinition.name" />
        }
        @case ('dropdown') {
          @if (dataForm) {
            <dash-gis-table-dropdown [formControlName]="fieldDefinition.name"
            [options]="dataFormField.dropdownItems"></dash-gis-table-dropdown>
            @if (dataFormField.parameter) {
              <dash-gis-table-db-dropdown
                [formControlName]="fieldDefinition.name"
                [formName]="tableDataFormName"
              [parameterValue]="dropdownParameterValue"></dash-gis-table-db-dropdown>
            }
          }
        }
      }
    </ng-container>
  </ng-container>
}

